'use strict';

import 'pages/page';
import 'components/application-close';
import 'components/recommended-action';
import 'components/system-notification';